<template>
  <div>
    <div class="history-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
      <i class="mdi mdi-history" aria-hidden="true"></i>&nbsp;{{ $t('recents.recents') }}&nbsp;&nbsp;
      <i class="mdi mdi-delete" style="color: red; cursor: pointer;" v-tooltip="$t('recents.removeAll')" aria-hidden="true" @click="removeHistory()"></i>
    </div>
    <div class="history-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important;">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-magnify" aria-hidden="true"></i></span>
        </b-input-group-prepend>
        <b-form-input style="border-right: 0;" v-model="search" @keyup="performSearch" size="sm" :placeholder="$t('recents.search')">
        </b-form-input>
        <b-input-group-append v-if="search.length > 0">
          <span class="input-group-text" style="padding: .1rem 0 !important; cursor: pointer; background-color: transparent; border-left: 0;" @click="clearSearch"><i class="mdi mdi-close" aria-hidden="true"></i></span>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div style="height: 100%; width: 100%; overflow-y: scroll; padding: 0 20px; text-align: center; background-color: #FFFFFF;">
      <div class="history-row" v-for="(h, i) in sortedHistory.slice().reverse()" :key="`sortedHistory${i}`">
        <span style="color: #007bff;" v-if="h.hangupCause === 'NORMAL_CLEARING' && h.answered">
          <i class="mdi mdi-arrow-bottom-right" aria-hidden="true" v-if="h.direction === 'Inbound'"></i>
          <i class="mdi mdi-arrow-top-left" aria-hidden="true" v-else></i>
          <span style="cursor: pointer;" @click="selectNumber(h.number)"><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ h.number }}</text-highlight></span>
          <br />{{ h.timeStamp | formatTimestamp(ampm, today, yesterday) }}
          <br />{{ h.duration | formatDuration }}
        </span>
        <span style="color: red;" v-else>
          <i class="mdi mdi-call-missed" aria-hidden="true" v-if="h.direction === 'Inbound'"></i>
          <i class="mdi mdi-arrow-top-left" aria-hidden="true" v-else></i>
          <span style="cursor: pointer;" @click="selectNumber(h.number)"><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ h.number }}</text-highlight></span>
          <br />{{ h.timeStamp | formatTimestamp(ampm, today, yesterday) }}
          <br />{{ h.duration | formatDuration }}
        </span>
        <br />
        <i class="mdi mdi-video" style="color: #007bff; cursor: pointer;" v-tooltip="$t('recents.videoCall')" aria-hidden="true" @click="makeHistoryVideoCall(h.number)"></i>&nbsp;&nbsp;
        <i class="mdi mdi-phone" style="color: #28a745; cursor: pointer;" v-tooltip="$t('recents.voiceCall')" aria-hidden="true" @click="makeHistoryCall(h.number)"></i>&nbsp;&nbsp;
        <span v-if="h.number !== 'Voicemail'"><i class="mdi mdi-message" style="color: #8500a7; cursor: pointer;" v-tooltip="$t('recents.message')" aria-hidden="true" @click="sendMessage(h.number)"></i>&nbsp;&nbsp;</span>
        <span v-if="h.number !== 'Voicemail'"><i class="mdi mdi-cancel" style="color: grey; cursor: pointer;" v-tooltip="$t('recents.block')" aria-hidden="true"></i>&nbsp;&nbsp;</span>
        <i class="mdi mdi-delete" style="color: red; cursor: pointer;" v-tooltip="$t('recents.remove')" aria-hidden="true" @click="removeHistoryCall(h)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import TextHighlight from 'vue-text-highlight';

export default {
  name: 'Recents',
  components: {
    'text-highlight': TextHighlight
  },
  mounted () {
    var self = this
    self.sortedHistory = self.history

    var today = new Date()
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    self.today = `${months[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`

    var yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)

    self.yesterday = `${months[yesterday.getMonth()]} ${yesterday.getDate()}, ${yesterday.getFullYear()}`
  },
  props: {
    history: {
      type: Array,
      required: true
    },
    makeHistoryVideoCall: {
      type: Function
    },
    makeHistoryCall: {
      type: Function
    },
    removeHistoryCall: {
      type: Function
    },
    removeHistory: {
      type: Function
    },
    ampm: {
      type: Boolean
    },
    selectNumber: {
      type: Function
    },
    sendMessage: {
      type: Function
    }
  },
  data () {
    return {
      today: null,
      yesterday: null,
      sortedHistory: [],
      search: '',
      queries: [],
      highlightStyle: { 'background-color': 'white', color: '#167bff', 'font-size': '1.15rem' }
    }
  },
  methods: {
    performSearch () {
      var self = this
      if (self.search.length <= 0) {
        self.sortedHistory = self.history
        self.queries = []
      } else {
        var tempHistory = []
        self.queries = []

        self.history.forEach ((hist) => {
          if (hist.number.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempHistory.push(hist)
          }
        })

        self.sortedHistory = tempHistory
        self.queries.push(self.search)
      }
    },
    performReload (history) {
      var self = this
      if (self.search.length <= 0) {
        self.sortedHistory = history
        self.queries = []
      } else {
        var tempHistory = []
        self.queries = []

        history.forEach ((hist) => {
          if (hist.number.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempHistory.push(hist)
          }
        })

        self.sortedHistory = tempHistory
        self.queries.push(self.search)
      }
    },
    clearSearch () {
      var self = this
      self.sortedHistory = self.history
      self.queries = []
      self.search = ''
    }
  }
}

</script>

<style>
.history-row {
  margin: 20px auto !important;
  width: auto;
  height: auto !important;
  clear: both !important;
  text-align: center !important;
}
</style>
